import { useMutation } from '@tanstack/react-query';

import { LoginFormDTO } from '@/shared/api';
import { Project } from '@/shared/config/projects';

import * as services from './login-form.services';

/**
 * Query-хук для отправки запроса на авторизацию
 */
export const useLogin = (project: Project) => {
  return useMutation({
    mutationFn: (data: LoginFormDTO) => services.login(project, data),
  });
};
